import { dev, prod, qa, uat } from "./userPoolCredentials";
import {
  devConfig,
  prodConfig,
  qaConfig,
  uatConfig,
} from "./routesApiAndConfig";

let baseUrl = window.location.origin;


const config = {
  ...(baseUrl.includes(".dev.")
    ? devConfig
    : baseUrl.includes(".qa.")
    ? qaConfig
    : baseUrl.includes(".uat.")
    ? uatConfig
    : prodConfig),//cambiar este  a devConfig para dev y a prodConfig para cuando pasamos a Prod
  AWS_SDK_LOAD_CONFIG: "1",
  REACT_APP_AWS_SDK_LOAD_CONFIG: "1",
};
const awsConfig = () => {
  if (baseUrl.includes(".dev.")) return { ...dev };
  if (baseUrl.includes(".qa.")) return { ...qa };
  if (baseUrl.includes(".uat.")) return { ...uat };
  return { ...prod };
};

const { region, poolId, clientId } = awsConfig();

// CHECK HERE*
const mode = "prod";

export default {
  REGION: region,
  POOL_ID: poolId,
  CLIENT_ID: clientId,
  REDIRECT_DEFAULT:
    config.REACT_APP_REDIRECT_DEFAULT || "https://www.errepar.com",
  LIST_URLs_REDIRECT_REPLACE:
    JSON.parse(config.REACT_APP_LIST_URLS_REDIRECT_REPLACE) || [],

  URL_NOTIFY_EAUTH:
    mode === "local"
      ? "eAuth/auth/notifyLoginUserEAuth"
      : config.REACT_APP_URL_NOTIFY_EAUTH,

  URL_ADMIN_SET_USER_PASSWORD:
    mode === "local"
      ? "eAuth/setPassword"
      : config.REACT_APP_URL_ADMIN_SET_USER_PASSWORD,

  URL_VERIFY_USER_COGNITO:
    mode === "local"
      ? "auth/getUser/verifyUserCognito"
      : config.REACT_APP_URL_VERIFY_USER_COGNITO,

  URL_GET_EMAIL_BY_NUMBER_SUSBCRIPTION:
    mode === "local"
      ? "eAuth/subscriptor/getEmailByNumberSubscription"
      : config.REACT_APP_URL_GET_EMAIL_BY_NUMBER_SUSBCRIPTION,

  URL_GET_AUTO_CREDENTIALS:
    mode === "local"
      ? "http://localhost:3005/auth/getAutoCredentialsEAuth"
      : config.REACT_APP_URL_GET_AUTO_CREDENTIALS,

  URL_GET_USER_INVITE:
    mode === "local" ? "invite" : config.REACT_APP_URL_GET_USER_INVITE,

  URL_VALIDATE_TOKEN:
    mode === "local"
      ? "http://localhost:3005/auth/validateToken"
      : config.REACT_APP_URL_VALIDATE_TOKEN,

  ECHO_ERREPAR:
    mode === "local"
      ? "https://accounts.errepar.com/echo"
      : config.ECHO_ERREPAR,

  IP_API:
    "https://ipapi.co/json/?key=M7b4ZlBUKzqx0v7rr4JNAnDTXUnj9Z6nTpyoLwLPh84pqZdz15",

  REDIRECT_DEFAULT_ME: config.URL_REDIRECT_DEFAULT_ME,

  POST_MESSAGE_URL_ME: config.POST_MESSAGE_URL_ME,

  URL_GENERATE_JWT3:
    mode === "local"
      ? "http://localhost:3005/eauth/auth/generateJwt3"
      : config.URL_GENERATE_JWT3,

  ANCESTOR_ORIGIN_ME:
    mode === "local" ? "http://127.0.0.1:5501/" : config.ANCESTOR_ORIGIN_ME,
  URL_GENERATE_LOGIN_USER_CREDENTIAL_EAUTH:
    mode === "local"
      ? "eAuth/auth/generateLoginUserCredentialEAuth" /* cambiar por "eAuth/auth/generateLoginUserCredentialEAuth"  al subirlo , en local cambiarlo a config.REACT_APP_URL_GENERATE_LOGIN_USER_CREDENTIAL_EAUTH porque no me anda localmente con el string que estaba   */
      : config.REACT_APP_URL_GENERATE_LOGIN_USER_CREDENTIAL_EAUTH,

  URL_AUTOLOGIN_EMAIL_USER_EAUTH: config.AUTOLOGIN_EMAIL_USER_EAUTH || "",

  URL_AUTOLOGIN_OAT_USER_EAUTH: config.AUTOLOGIN_OAT_USER_EAUTH || "",

  REDIRECT_DEFAULT_CGI: config.URL_REDIRECT_DEFAULT_CGI,

  URL_IFRAME_ALICUOTAS: config.URL_IFRAME_ALICUOTAS,

  TERMS_AND_CONDITIONS_URL: config.TERMS_AND_CONDITIONS_URL,

  URL_RECORD_ACCOUNT_LOGIN_FAIL: config.URL_RECORD_ACCOUNT_LOGIN_FAIL,

  URL_GET_JOB_CREDENTIALS: config.URL_GET_JOB_CREDENTIALS,

  URL_LOGOUT_ME: config.URL_LOGOUT_ME,

  ANCESTOR_ORIGIN_ME_DECLARATIONS: config.ANCESTOR_ORIGIN_ME_DECLARATIONS,

  ANCESTOR_ORIGIN_ME_MIGRATION: config.ANCESTOR_ORIGIN_ME_MIGRATION,

  ANCESTOR_ORIGIN_ME_EVENTANILLA: config.ANCESTOR_ORIGIN_ME_EVENTANILLA,

  URL_SESSIONS: config.URL_SESSIONS,
  ANCESTOR_ORIGIN_WEBAPP_ME_EVENTANILLA: config.ANCESTOR_ORIGIN_WEBAPP_ME_EVENTANILLA,

  LOGIN_ACCOUNT: config.LOGIN_ACCOUNT,
  SUBMIT_NEW_USER: config.REACT_APP_URL_SUBMIT_NEW_USER,
  RESEND_CONFIRMATION_EMAIL: config.REACT_APP_URL_RESEND_CONFIRMATION_EMAIL,

  REACT_GOOGLE_AUTH_CLIENT_ID: config.REACT_GOOGLE_AUTH_CLIENT_ID,
};
